import { ElMessageBox, type IElMessageBox } from 'element-plus'
import 'element-plus/theme-chalk/el-message-box.css'
import type { SFCInstallWithContext } from 'element-plus/es/utils'
import type AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'
import type { AxiosRequestConfig } from 'axios'
import type { ElMessageBoxOptions } from 'element-plus/lib/components/message-box/src/message-box.type'
import { isNullOrUndefinedOrWhiteSpace } from '@vantis/shared'

export default abstract class BaseErrorHandler {
    protected t: any = ()=>{};
    protected ElMessageBox: SFCInstallWithContext<IElMessageBox> = ElMessageBox;
    protected abstract Code: string;
    protected Message: string;
    protected abstract AlertType: AlertTypeEnum;
    protected ShowCode: boolean;
    protected ShowMessage:boolean;
    constructor(messageKey?: string, message?: string,responseConfig?:AxiosRequestConfig, showCode: boolean = true,showMessage:boolean=true) {
        this.ShowCode = showCode;
        this.ShowMessage=showMessage;
        if (!isNullOrUndefinedOrWhiteSpace(messageKey)) {
            this.Message = this.t(messageKey);
        } else {
            this.Message = message ?? "Error";
        }
    }

    public handle() {
        const options: ElMessageBoxOptions = {
            dangerouslyUseHTMLString: true,
            type: this.AlertType,
            showClose: false,
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            title: this.ShowCode ? this.t(this.Code) : "",
            message: this.Message
        };
        if (this.ElMessageBox && this.ShowMessage) {
            this.ElMessageBox({
                ...options,
            }).then((res) => {
                if (res === "confirm") {
                    this.customizeAction();
                }
            });
        }else {
            this.customizeAction();
        }
    }

    public abstract customizeAction(): void;
}
